"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _filter = _interopRequireDefault(require("./filter.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Icon = function Icon() {
  return _react["default"].createElement("svg", {
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12"
  }, _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    transform: "translate(-279.000000, -110.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(73.000000, 100.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(204.000000, 8.000000)"
  }, _react["default"].createElement("g", null, _react["default"].createElement("g", {
    transform: "translate(2.000000, 2.000000)",
    stroke: "#808080"
  }, _react["default"].createElement("circle", {
    cx: "5",
    cy: "5",
    r: "4.5"
  }), _react["default"].createElement("path", {
    d: "M8.5,8.5 L11.5,11.5",
    strokeLinecap: "square"
  })), _react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "16",
    height: "16"
  })))))));
};

var Filter = function Filter(_ref) {
  var onInput = _ref.onInput;
  return _react["default"].createElement("div", {
    className: _filter["default"]['filter']
  }, _react["default"].createElement("input", {
    onInput: onInput,
    placeholder: 'Filter'
  }), _react["default"].createElement(Icon, null));
};

Filter.propTypes = {};
Filter.defaultProps = {};
var _default = Filter;
exports["default"] = _default;